export default __webpack_public_path__ + "static/media/m-icon-gnb-btn-menu.1394200c.svg";